import { toast } from "react-toastify";

import { NotifyPositionEnum, NotifyThemeEnum, NotifyTypeEnum } from "../../constants/notify";
import type { INotifyOptions } from "../../types/notify";

const DEFAULT_NOTIFY_OPTIONS: INotifyOptions = {
  position: NotifyPositionEnum.TOP_RIGHT,
  type: NotifyTypeEnum.INFO,
  theme: NotifyThemeEnum.LIGHT,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  draggable: true,
  pauseOnHover: true,
  closeButton: false,
  style: {
    whiteSpace: "nowrap",
    width: "fit-content"
  }
};

export const notify = (msg: string, type?: NotifyTypeEnum, options?: Partial<Omit<INotifyOptions, "type">>) => {
  return toast(<pre className="m-0 max-h-[400px] overflow-y-auto">{msg}</pre>, {
    ...DEFAULT_NOTIFY_OPTIONS,
    ...options,
    type: type || NotifyTypeEnum.DEFAULT,
    progressClassName: "!absolute !bottom-0 !left-0 !right-0"
  });
};
